import React from 'react';

import { UserProfileLink } from '@components/link';

export const IssuerCell = ({ issuer }) => {
  return <UserProfileLink id={issuer.id} text={issuer.displayName} />;
};
